import "./WhoWeAre.module.css";
import Header from "@/reusable_sections/Header";
import Story from "./sections/Story";
import Mission from "./sections/Mission";
import Team from "./sections/Team";
import Footer from "@/reusable_sections/Footer";
import Ceostory from "./sections/Ceostory";
export default function WhoWeArePage() {
  return <div>
      <Header />
      <Story />
      <Team />
      <Ceostory />
      <Mission />
      <Footer />
    </div>;
}